export const buttonToTop = {
    label: "Retourner en haut de la page"
}